import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import Button from '@mui/material/Button';
// @mui
import PageHeader from '../components/sectionComponent/PageHeader';


// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const [openFilter, setOpenFilter] = useState(false);
  const navigate = useNavigate();

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };




  return (
    <>
      <Helmet>
        <title> 제품소개 | RainDrop </title>
      </Helmet>
      <PageHeader data={'제품소개'} />
    <Button variant="contained" onClick={()=> {navigate('/license', { replace: true })}} >라이센스</Button>  
    </>
  );
}
